import React, { useRef, useState } from 'react';
import { GoogleButton } from '../../user/google-button';
import { center, flexRoot, vertical } from 'csstips';
import { style } from 'typestyle';
import { px } from 'csx';
import { ComponentProps, deps, inject, observer } from '../../../lib/component';
import { centerCenter } from 'csstips/lib/flex';
import { spacing } from '../../../theme/spacing';
import { rebrand } from '../../../theme/color';
import { LabelledCheckbox } from '../atoms/controls/LabelledCheckbox';
import { preventAndCall } from '../utilities/functions';

const styles = {
  form: style(flexRoot, vertical, center, {
    marginTop: spacing.XLARGE,
  }),
  checkbox: style(vertical, centerCenter, {
    textAlign: 'left',
    color: rebrand.contrast[40].toString(),
    $nest: {
      '& a': {
        fontWeight: 'bold',
      },
    },
  }),
  checkboxErrorInput: style({
    borderColor: rebrand.semantic['error'][70].toHexString(),
    backgroundColor: rebrand.semantic['error'][10].toHexString(),
  }),
  error: style({
    fontSize: px(12),
    marginTop: px(8),
    marginBottom: 0,
    color: rebrand.semantic['error'][70].toHexString(),
  }),
  button: style({
    height: px(48),
    marginTop: spacing.XLARGE,
  }),
};

export const SignUpForm: React.FC<ComponentProps> = inject(deps)(
  observer(({ model, controller }) => {
    const formRef = useRef<HTMLFormElement>();
    const [formIsDirty, setFormIsDirty] = useState(false);
    const [termsAccepted, setTermsAccepted] = useState(false);

    const { youtubeLoginURL } = model.auth;
    const { showTermsConditionsModal, showPrivacyPolicyModal } = controller.onboarding;

    const showErrors = formIsDirty && !termsAccepted;

    const toggleTermsAccepted = () => {
      setTermsAccepted((val) => !val);
    };

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();

      setFormIsDirty(true);

      controller.analytics.sendMixpanel('User clicks "Sign up with Google" button', {
        termsChecked: termsAccepted,
      });

      if (!termsAccepted) return;

      window.location.href = youtubeLoginURL;
    };

    return (
      <form action={youtubeLoginURL} method="get" className={styles.form} ref={formRef} onSubmit={handleSubmit}>
        <div className={styles.checkbox}>
          <LabelledCheckbox onChange={toggleTermsAccepted} checked={termsAccepted} required isValid={!showErrors}>
            I accept the{' '}
            <a href="/terms-and-conditions" onClick={preventAndCall(showTermsConditionsModal)}>
              Terms and Conditions
            </a>{' '}
            and{' '}
            <a href="/privacy-policy" onClick={preventAndCall(showPrivacyPolicyModal)}>
              Privacy Policy
            </a>
          </LabelledCheckbox>

          {showErrors && <p className={styles.error}>Please agree to the terms and policy</p>}
        </div>

        <GoogleButton className={styles.button} onClick={handleSubmit} data-test-signup-button-google />
      </form>
    );
  })
);
